const STORAGE_KEY = 'payment-reminder-dismissed';

const today = () => new Date().toISOString().slice(0, 10);

/** Что именно показывали — чтобы смена состояния за день не осталась незамеченной. */
export type ReminderKind = 'overdue' | 'due-soon';

const stamp = (kind: ReminderKind) => `${kind}:${today()}`;

/**
 * Плашка показывается раз в сутки: закрыли — до конца дня больше не мешаем.
 * Хранится дата вместе с видом напоминания, а не флаг: назавтра оно вернётся само,
 * а если «скоро срок» успело смениться на «просрочено» — покажем сразу, не дожидаясь
 * следующего дня.
 */
export const isDismissedToday = (kind: ReminderKind): boolean => {
  if (typeof window === 'undefined') return false;

  try {
    return localStorage.getItem(STORAGE_KEY) === stamp(kind);
  } catch {
    // приватный режим — покажем ещё раз, это не страшно
    return false;
  }
};

export const dismissForToday = (kind: ReminderKind): void => {
  if (typeof window === 'undefined') return;

  try {
    localStorage.setItem(STORAGE_KEY, stamp(kind));
  } catch {
    // не удалось запомнить — плашка появится снова, данные не теряются
  }
};
